import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'src/app/shared/shared.module';
import { SuperAdminRoutingModule } from './super-admin-routing.module';

import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SuperAdminComponent } from './super-admin.component';



@NgModule({
  declarations: [
    DashboardComponent, 
    SuperAdminComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SuperAdminRoutingModule
  ]
})
export class SuperAdminModule { }
